import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const services = [
  {
    icon: 'ri-oil-line',
    title: 'Troca de Óleo e Filtro',
    description: 'Mantenha seu importado saudável com troca de óleo. Performance superior e longevidade garantidas com produtos premium.',
    detail: 'Utilizamos óleos sintéticos das melhores marcas como Liqui-Moly, Castrol e Mobil, garantindo proteção máxima ao motor do seu importado.',
  },
  {
    icon: 'ri-car-line',
    title: 'Sistema de Freios',
    description: 'Sua segurança em primeiro lugar. Serviço de freio especializado para paradas precisas e tranquilidade na estrada.',
    detail: 'Diagnóstico completo do sistema de freios, substituição de pastilhas, discos, fluido e calibração do ABS com equipamentos de última geração.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Mecânica Geral',
    description: 'Desempenho excepcional em cada quilômetro. Mecânica geral confiável para seu veículo importado.',
    detail: 'Manutenção preventiva e corretiva completa, com profissionais certificados pelas principais marcas do mercado.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Suspensão',
    description: 'Condução suave assegurada. Soluções eficazes para manter a suspensão do seu importado em perfeito estado.',
    detail: 'Alinhamento, balanceamento, troca de amortecedores, molas e buchas com equipamentos de precisão milimétrica.',
  },
  {
    icon: 'ri-loop-right-line',
    title: 'Correia Dentada',
    description: 'Garanta eficiência. Troca de correia dentada para manter seu motor importado confiável e em ordem.',
    detail: 'Substituição completa do kit de correia dentada com peças originais ou de primeira linha, seguindo as especificações do fabricante.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Fluido de Transmissão',
    description: 'Transmissão suave, vida útil prolongada. Faça a troca do fluido de transmissão e garanta durabilidade.',
    detail: 'Troca de fluido de transmissão automática e manual, com produtos específicos para cada modelo e marca de veículo importado.',
  },
];

export default function Services() {
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const { ref: headerRef, visible: headerVisible } = useScrollReveal();
  const { ref: gridRef, visible: gridVisible } = useScrollReveal();
  const { ref: ctaRef, visible: ctaVisible } = useScrollReveal();

  return (
    <section id="servicos" className="relative py-24 overflow-hidden" style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 20%, #e8e8e8 40%, #f5f5f5 60%, #ebebeb 80%, #ffffff 100%)' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#aaaaaa]/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#aaaaaa]/40 to-transparent"></div>
        <div className="absolute top-1/4 -left-32 w-[500px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(180,180,180,0.25) 0%, transparent 70%)' }}></div>
        <div className="absolute bottom-1/4 -right-32 w-[500px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(160,160,160,0.2) 0%, transparent 70%)' }}></div>
        <div className="absolute top-0 right-0 w-px h-full bg-gradient-to-b from-transparent via-[#aaaaaa]/20 to-transparent"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full" style={{ background: 'radial-gradient(ellipse, rgba(220,220,220,0.4) 0%, transparent 65%)' }}></div>
        <div className="absolute top-0 left-0 w-full h-full" style={{ background: 'linear-gradient(105deg, rgba(255,255,255,0.9) 0%, rgba(210,210,210,0.3) 30%, rgba(255,255,255,0.6) 50%, rgba(195,195,195,0.25) 70%, rgba(255,255,255,0.9) 100%)' }}></div>
      </div>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div>
            <span className="inline-block text-sm font-semibold tracking-widest uppercase mb-4" style={{ color: '#888888' }}>
              O que fazemos
            </span>
            <h2
              className="text-4xl md:text-5xl font-black"
              style={{ fontFamily: "'Playfair Display', serif", color: '#111111' }}
            >
              Nossos <span style={{ color: '#222222' }}>Serviços</span>
            </h2>
          </div>
          <p className="text-sm max-w-sm" style={{ color: '#777777' }}>
            Cada serviço realizado com precisão técnica e os melhores produtos do mercado.
          </p>
        </div>

        {/* Services Grid */}
        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, i) => (
            <div
              key={i}
              className={`group relative border rounded-2xl p-7 cursor-pointer overflow-hidden transition-all duration-500 hover:-translate-y-2 ${
                activeCard === i ? 'border-[#888888]/70' : 'border-[#cccccc]/60 hover:border-[#888888]/60'
              } ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{
                background: activeCard === i
                  ? 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 50%, #e8e8e8 100%)'
                  : 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 50%, #eeeeee 100%)',
                transitionDelay: gridVisible ? `${i * 80}ms` : '0ms',
                boxShadow: '0 0 0 0 rgba(0,0,0,0)',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 16px 40px rgba(0,0,0,0.10)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 0 0 0 rgba(0,0,0,0)';
              }}
              onClick={() => setActiveCard(activeCard === i ? null : i)}
            >
              {/* Shimmer overlay on hover */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{ background: 'linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.55) 50%, transparent 70%)', transform: 'skewX(-15deg) translateX(-100%)', animation: 'none' }}>
              </div>
              {/* Animated top border line */}
              <div className="absolute top-0 left-0 h-[3px] w-0 group-hover:w-full transition-all duration-500 rounded-t-2xl"
                style={{ background: 'linear-gradient(90deg, #555555, #aaaaaa)' }}>
              </div>

              <div className="w-14 h-14 flex items-center justify-center rounded-xl border mb-5 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', borderColor: 'rgba(170,170,170,0.5)' }}>
                <i className={`${service.icon} text-2xl transition-all duration-300 group-hover:text-[#333333]`} style={{ color: '#666666' }}></i>
              </div>
              <h3 className="font-bold text-lg mb-3 transition-colors duration-300 group-hover:text-[#111111]" style={{ fontFamily: "'Playfair Display', serif", color: '#333333' }}>
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed mb-4 transition-colors duration-300 group-hover:text-[#555555]" style={{ color: '#777777' }}>
                {service.description}
              </p>
              {activeCard === i && (
                <p className="text-sm leading-relaxed border-t pt-4 mt-2" style={{ color: '#888888', borderColor: 'rgba(170,170,170,0.4)' }}>
                  {service.detail}
                </p>
              )}
              <a
                href="https://api.whatsapp.com/send/?phone=5519997889998&text=Olá, gostaria de agendar um serviço&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center gap-2 text-sm font-semibold mt-4 group-hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ color: '#555555' }}
              >
                Agendar Serviço
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          ref={ctaRef as React.RefObject<HTMLDivElement>}
          className={`mt-16 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 border transition-all duration-700 ${ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #f0f0f0 100%)', borderColor: 'rgba(170,170,170,0.5)' }}
        >
          <div>
            <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#333333' }}>
              Não encontrou o serviço que precisa?
            </h3>
            <p className="text-sm" style={{ color: '#777777' }}>
              Entre em contato e nossos especialistas vão te ajudar com qualquer necessidade do seu importado.
            </p>
          </div>
          <a
            href="https://api.whatsapp.com/send/?phone=5519997889998&text=Olá, preciso de ajuda com meu importado&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 font-bold px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #555555 0%, #888888 50%, #aaaaaa 100%)', color: '#ffffff' }}
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Falar com Especialista
          </a>
        </div>
      </div>
    </section>
  );
}
